const hrActionRoute = {
  BASE_PATH: "/hr-action-management",
  addPath: function () {
    return this.BASE_PATH + "/create";
  },
  editPath: function (id: number | string) {
    return `${this.BASE_PATH}/${id}/edit`;
  },
};

export default hrActionRoute;
